import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function PenIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "10"}
      height={height || "10"}
      viewBox="0 0 10 10"
    >
      <path
        id="Path_10157"
        data-name="Path 10157"
        d="M5.679-6.929.251-1.5,0,.729a.469.469,0,0,0,.517.518L2.749,1,8.179-4.429ZM9.725-7.3,8.551-8.475a.938.938,0,0,0-1.326,0l-1.1,1.1,2.5,2.5,1.1-1.1A.938.938,0,0,0,9.725-7.3Z"
        transform="translate(0 8.75)"
        fill={color || "#fb972e"}
      />
    </svg>
  );
}
